import { useState } from 'react'
// import amo from '../assets/img/logo/amocrm.svg'
// import bitrix from '../assets/img/logo/bitrix24.png'
import CloseSvg from '../assets/img/svg/close'
import SaveSvg from '../assets/img/svg/save'
// import FromEnties from '../enties/from-enties'
// import ModalLine from '../enties/modal-line'
// import ModalLineAdd from '../enties/modal-line-add'
// import ToEnties from '../enties/to-enties'
// import API from '../hooks/requests'
import FromSource from '../enties/from-source'
import AblefyQuentn from '../enties/ablefyQuentn'
import AblefyClose from '../enties/ablefyClose'
import QuentnClose from '../enties/quentnClose'
import QuentnAblefy from '../enties/quentnAblefy'
import StopSvg from '../assets/img/svg/stop'

const CreateBundle = ({
  source,
  setSource,
  action,
  setAction,
  close,
  fieldsQuentn,
  setFieldsQuentn,
  fieldsClose,
  setFieldsClose,
  fieldsAblefy,
  setFieldsAblefy,
  toast,
  // from,
  // setFrom,
  // to,
  // setTo,
  // trg,
  // setTrg,
  // action,
  // setAction,
  // dataFields,
  // setDataFields,
  // setDataList,
}) => {
  const load = useState(false)
  // const [load, setLoad] = useState(false)
  // const [optTrigger, setOptTrigger] = useState([])
  // const [optAction, setOptAction] = useState([])
  // const [statusAddField, setStatusAddField] = useState(false)
  // const gray = '#d9d9d9'
  // const red = ' #ff665c'

  const optSource = [
    { value: 'ablefy', label: 'Ablefy' },
    { value: 'quentn', label: 'Quentn' },
  ]

  const optAction = [
    { value: 'purchase', label: 'Purchase' },
    { value: 'chargeback', label: 'Chargeback' },
  ]

  // const msgUp = () => {
  //   setStatusAddField(true)
  //   setTimeout(() => {
  //     setStatusAddField(false)
  //   }, 1500)
  // }

  return (
    <div className="modal-column">
      <div className="modal-topbar">
        <div className="modal-close" onClick={close}>
          <CloseSvg />
          <span>Back to list</span>
        </div>
        <div
          className="modal-save"
          onClick={() => {
            toast(
              <span className="notify_-copy-link">
                <StopSvg />
                <span>Not all fields are filled in!</span>
              </span>
            )
            // if (from && to && from !== to && trg.value && action.value) {
            //   if (
            //     (trg.value.includes('delet') &&
            //       action.value.includes('delet')) ||
            //     (trg.value.includes('note') &&
            //       action.value === 'action_oncrmtimelinecommentadd') ||
            //     (trg.value.includes('oncrmtimelinecommentadd') &&
            //       action.value.includes('note')) ||
            //     Object.keys(dataFields).length !== 0
            //   ) {
            //     close()
            //     API.postBundle({
            //       from_crm: from,
            //       to_crm: to,
            //       from_trigger: trg.value,
            //       from_trigger_label: trg.label,
            //       to_action: action.value,
            //       to_action_label: action.label,
            //       field: JSON.stringify(dataFields),
            //       status: true,
            //     }).then(() => {
            //       API.getBundleList().then((r) => {
            //         setDataList(r.data.data)
            //       })
            //     })
            //   } else {
            //     msgUp()
            //   }
            // } else {
            //   msgUp()
            // }
          }}
        >
          <SaveSvg />
        </div>
      </div>
      {!load ? (
        <div className="load-data">Getting data from source...</div>
      ) : (
        <div className="create-bundle">
          <FromSource
            source={source}
            action={action}
            optSource={optSource}
            optAction={optAction}
            callbackSource={(e) => {
              setSource(e.value)
              setAction('')
              setFieldsQuentn([])
              setFieldsClose([])
              setFieldsAblefy([])
            }}
            callbackAction={(e) => {
              setAction(e.value)
            }}
          />
          {source === 'ablefy' && (
            <>
              <AblefyQuentn fields={fieldsQuentn} setFields={setFieldsQuentn} />
              <AblefyClose fields={fieldsClose} setFields={setFieldsClose} />
            </>
          )}
          {source === 'quentn' && (
            <>
              <QuentnClose fields={fieldsClose} setFields={setFieldsClose} />
              <QuentnAblefy fields={fieldsAblefy} setFields={setFieldsAblefy} />
            </>
          )}
          {/* <FromEnties
          from={from}
          optCRM={optCRM}
          trg={trg.value}
          callbackCRM={(e) => {
            // setDataFields([])
            // setFrom(e.value)
          }}
          callback={(e) => {
            // setDataFields([])
            // setTrg(e)
            // setOptTrigger(e.field)
          }}
        />
        <ToEnties
          to={to}
          from={from}
          gray={gray}
          red={red}
          optCRM={optCRM}
          action={action.value}
          callbackCRM={(e) => {
            // setDataFields([])
            // setTo(e.value)
          }}
          callback={(e) => {
            // setDataFields([])
            // setAction(e)
            // setOptAction(e.field)
          }}
        /> */}
        </div>
      )}
      <div className="modal-column-flex">
        {/* <div className="modal-column-flex-title">
          <span>
            <h4>Настройка полей</h4>
          </span>
        </div> */}
        {/* <ModalLineState /> */}
        {/* {dataFields.map((e) => (
          <ModalLine
            key={e.key}
            trigger={e.trigger}
            triggerVal={e.triggerValue}
            action={e.action}
            actionVal={e.actionValue}
            optTrigger={optTrigger}
            optAction={optAction}
            deleteCallback={() =>
              setDataFields(dataFields.filter((f) => f.key !== e.key))
            }
            optCallback={(c) => {
              setDataFields((dataFields) =>
                dataFields.map((m) =>
                  m.key === e.key ? { ...m, trigger: c.value } : m
                )
              )
            }}
            optActCallback={(c) => {
              setDataFields((dataFields) =>
                dataFields.map((m) =>
                  m.key === e.key ? { ...m, action: c.value } : m
                )
              )
            }}
            valueCallback={(c) => {
              setDataFields((dataFields) =>
                dataFields.map((m) =>
                  m.key === e.key ? { ...m, triggerValue: c.target.value } : m
                )
              )
            }}
            valueActCallback={(c) => {
              setDataFields((dataFields) =>
                dataFields.map((m) =>
                  m.key === e.key ? { ...m, actionValue: c.target.value } : m
                )
              )
            }}
          />
        ))}
        <ModalLineAdd
          callback={() => {
            if (from && to && from !== to && trg.value && action.value) {
              setDataFields([
                ...dataFields,
                {
                  key: new Date().getTime(),
                  trigger: '',
                  triggerValue: '',
                  action: '',
                  actionValue: '',
                },
              ])
            } else {
              setStatusAddField(true)
              setTimeout(() => {
                setStatusAddField(false)
              }, 1500)
            }
          }}
          status={statusAddField}
        /> */}
      </div>
    </div>
  )
}

export default CreateBundle
